import React, { ComponentProps } from "react";

export default function PlusIcon({
  variant,
  ...props
}: ComponentProps<"svg"> & { variant?: "thick" | "thin" }) {
  if (variant === "thick") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M5 10H15M10 15L10 5"
          stroke="white"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M6.5 12.5C6.22386 12.5 6 12.2761 6 12C6 11.7239 6.22386 11.5 6.5 11.5L17.5 11.5C17.7761 11.5 18 11.7239 18 12C18 12.2761 17.7761 12.5 17.5 12.5L6.5 12.5Z"
        fill="white"
      />
      <path
        d="M12 18C11.7239 18 11.5 17.7761 11.5 17.5L11.5 6.5C11.5 6.22386 11.7239 6 12 6C12.2761 6 12.5 6.22386 12.5 6.5L12.5 17.5C12.5 17.7761 12.2761 18 12 18Z"
        fill="white"
      />
    </svg>
  );
}
